// Casca da tela de Aniversários. O header e o corpo moram no componente
// BirthdaySettings — aqui fica só o container, como nas demais telas Aeros.
import React from "react";

import MainContainer from "../../components/MainContainer";
import BirthdaySettings from "../../components/BirthdaySettings";

const BirthdaySettingsPage = () => (
  <MainContainer>
    <BirthdaySettings />
  </MainContainer>
);

export default BirthdaySettingsPage;
